module.exports = __webpack_public_path__ + "img/map.14390d45.jpg";